import React, {Component} from 'react';
import DefaultModal from "../../invoice/DefaultModal";
import {showAxiosError} from "../../../helper/helper";
import {generateURL, request} from "../../../helper/APIUtils";
import Alert from 'react-s-alert';
import '../../../local_node_modules/react-select/dist/react-select.css';
import Table from "../../../components/Table/Table";
import {Input, UncontrolledTooltip} from "reactstrap";
import moment from "moment/moment";
import ReactLoading from "react-loading";

class XMLDownlaodRequestModal extends Component {

	constructor(props) {
		super(props);
		this.state ={
			confirmBtnDisabled :false,
            loading:true,
            requestMap:[],
            type:"request",
            downloadXmlRequest: {}
		};
		this.onChangeChecked          = this.onChangeChecked.bind(this);
		this.deleteCustomerXMLRequest = this.deleteCustomerXMLRequest.bind(this);
        this.confirm        = this.confirm.bind(this);
        this.getList        = this.getList.bind(this);
	}

	componentDidMount () {
		this.getList();
	}

	getList(){
        let self = this;
        let params = {
            url: `/customerXMLDownload/getCustomerXMLCount`,
            method: "post",
            data: self.props.vknTckn
        };
        self.setState({loading:true});
        request(params)
        .then(function (response) {
            let result = response.data;
            if(result.downloadXMLRequestStates instanceof Array){
                self.setState({loading:false, requestMap:result.downloadXMLRequestStates,type:"request", downloadXmlRequest: result});
            }else{
                self.setState({loading:false, requestMap:(result.requestParts || []),type:"result"});
            }
        }).catch(function (error) {
            self.setState({loading:false});
            showAxiosError(error);
        });
    }

    deleteCustomerXMLRequest(){
        let self = this;
        let params = {
            url: `/customerXMLDownload/deleteCustomerXMLRequest`,
            method: "post",
            data: self.props.vknTckn
        };
        self.setState({loading:true});
        request(params)
        .then(function (response) {
            Alert.success(response.data,{
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
            self.setState({loading:false, requestMap:[],type:"request"});
            self.getList();
        }).catch(function (error) {
            self.setState({loading:false});
            showAxiosError(error);
        });
    }

	confirm(){
		let self = this;

        let found = self.state.requestMap.find(function (obj) {
            return (obj.inboxDownload || obj.inboxAppResponseDownload || obj.outboxDownload || obj.outboxAppResponseDownload || obj.archiveDownload ||
                obj.despatchInboxDownload || obj.inboxReceiptAdviceDownload || obj.despatchOutboxDownload || obj.outboxReceiptAdviceDownload ||
                obj.raporDownload || obj.mustahsilMakbuzDownload || obj.serbestMeslekMakbuzDownload || obj.edovizDownload || obj.edovizRaporDownload ||
                obj.eadisyonDownload)
        });

        if(!found){
            Alert.error("En az 1 adet seçili xml indirme isteğiniz bulunmalıdır.", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
            return;
        }

        let params = {
            url: `/customerXMLDownload/confirmCustomerXMLRequest/${self.props.vknTckn}`,
            method: "post",
            data: self.state.requestMap
        };
        self.setState({confirmBtnDisabled:true});
        request(params)
        .then(function (response) {
            Alert.success(response.data, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
            self.getList();
        }).catch(function (error) {
            showAxiosError(error);
        }).then(function () {
            self.setState({confirmBtnDisabled:false});
        });
	}

	onChangeChecked(index,name,value){
	    let self = this;
	    let requestMap = self.state.requestMap;
	    requestMap[index][name]=value;
	    self.setState({requestMap});
    }

    getUrl(row) {
        let url = `api/customerXMLDownload/downloadZip?vknTckn=${row.vknTckn}&recordId=${row.recordId}`;
        return generateURL(url);
    }

    getState(row){
        let htmlResult = "";
        if (row.state === 0) {
            htmlResult = "İşlem Kuyrukta";
        } else if (row.state === 1) {
            htmlResult = "İşleniyor";
        } else if (row.state === 2) {
            htmlResult = "İşlem Başarılı";
        } else if (row.state === 3) {
            htmlResult = "İşlem Hatalı";
        } else {
            htmlResult = "";
        }
        return (
            <div>
                <p style={{margin:0}} className={(row.state === 3 ? "text-danger" :(row.state === 2 ? "text-success" : row.state === 1 ? "text-warning" : "text-info"))} id={"request_state_" + row.recordId}>{htmlResult}</p>
                {row.state === 3 &&
                    <UncontrolledTooltip placement="bottom" target={"request_state_" + row.recordId} delay={0}>
                    {row.resultExplanation}
                    </UncontrolledTooltip>
                }
            </div>
        );
    }

    getTypeName(type){
	    switch (type) {
            case "inbox":
                return "Gelen Fatura";
            case "inbox_app_response":
                return "Gelen Uyg. Yanıtı";
            case "outbox":
                return "Giden Fatura";
            case "outbox_app_response":
                return "Giden Uyg. Yanıtı";
            case "archive":
                return "Arşiv Fatura";
            case "rapor":
                return "Arşiv Rapor";
            case "despatch_inbox":
                return "Gelen İrsaliye";
            case "inbox_receipt":
                return "Gelen İrs. Yanıtı";
            case "despatch_outbox":
                return "Giden İrsaliye";
            case "outbox_receipt":
                return "Giden İrs. Yanıtı";
            case "mustahsil_makbuz":
                return "Müstahsil Makbuz";
            case "serbest_meslek_makbuz":
                return "Serbest Meslek Makbuz";
            case "eadisyon":
                return "eAdisyon";
            case "edoviz":
                return "eDöviz";
            case "edoviz_rapor":
                return "eDöviz Rapor";
            default:
                return "Bilinmeyen"
        }
    }

	render() {
        let columns = [
            {
                Header: "Yıl",
                accessor: "year",
                sortable: false,
                Cell: (row, index) => (<div style={{backgroundColor: "lightgreen"}}>{index + ".Part"}</div>)
            }
        ];

        const downloadXmlRequest = this.state.downloadXmlRequest;
        if (downloadXmlRequest.showEinvoice) {
            columns.push(
                {
                    Header: "Gelen Fatura",
                    accessor: "inboxCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.inboxCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.inboxCount + " Adet"}</p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.inboxDownload} onChange={(e) => this.onChangeChecked(index, "inboxDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                },
                {
                    Header: "Gelen Uyg. Ynt.",
                    accessor: "inboxAppResponseCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.inboxAppResponseCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.inboxAppResponseCount + " Adet"}</p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.inboxAppResponseDownload} onChange={(e) => this.onChangeChecked(index, "inboxAppResponseDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                },
                {
                    Header: "Giden Fatura",
                    accessor: "outboxCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.outboxCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.outboxCount + " Adet"}</p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.outboxDownload} onChange={(e) => this.onChangeChecked(index, "outboxDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                },
                {
                    Header: "Giden Uyg. Ynt.",
                    accessor: "outboxAppResponseCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.outboxAppResponseCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.outboxAppResponseCount + " Adet"} </p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.outboxAppResponseDownload} onChange={(e) => this.onChangeChecked(index, "outboxAppResponseDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                }
            );
        }

        if (downloadXmlRequest.showEarcihveInvoice) {
            columns.push(
                {
                    Header: "Arşiv Fatura",
                    accessor: "archiveCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.archiveCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.archiveCount + " Adet"}</p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.archiveDownload} onChange={(e) => this.onChangeChecked(index, "archiveDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                }
            );
        }

        if (downloadXmlRequest.showEdespatch) {
            columns.push(
                {
                    Header: "Gelen İrsaliye",
                    accessor: "despatchInboxCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.despatchInboxCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.despatchInboxCount + " Adet"}</p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.despatchInboxDownload} onChange={(e) => this.onChangeChecked(index, "despatchInboxDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                },
                {
                    Header: "Gelen İrs. Ynt.",
                    accessor: "inboxReceiptAdviceCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.inboxReceiptAdviceCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.inboxReceiptAdviceCount + " Adet"}</p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.inboxReceiptAdviceDownload} onChange={(e) => this.onChangeChecked(index, "inboxReceiptAdviceDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                },
                {
                    Header: "Giden İrsaliye",
                    accessor: "despatchOutboxCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.despatchOutboxCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.despatchOutboxCount + " Adet"}</p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.despatchOutboxDownload} onChange={(e) => this.onChangeChecked(index, "despatchOutboxDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                },
                {
                    Header: "Giden İrs. Yanıtı",
                    accessor: "outboxReceiptAdviceCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.outboxReceiptAdviceCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.outboxReceiptAdviceCount + " Adet"}</p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.outboxReceiptAdviceDownload} onChange={(e) => this.onChangeChecked(index, "outboxReceiptAdviceDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                }
            );
        }

        if (downloadXmlRequest.showMustahsilMakbuz) {
            columns.push(
                {
                    Header: "Müstahsil Makbuz",
                    accessor: "mustahsilMakbuzCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.mustahsilMakbuzCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.mustahsilMakbuzCount + " Adet"}</p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.mustahsilMakbuzDownload} onChange={(e) => this.onChangeChecked(index, "mustahsilMakbuzDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                }
            );
        }

        if (downloadXmlRequest.showSerbestMeslekMakbuz) {
            columns.push(
                {
                    Header: "Serbest Meslek Makbuz",
                    accessor: "serbestMeslekMakbuzCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.serbestMeslekMakbuzCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.serbestMeslekMakbuzCount + " Adet"}</p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.serbestMeslekMakbuzDownload} onChange={(e) => this.onChangeChecked(index, "serbestMeslekMakbuzDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                }
            );
        }

        if (downloadXmlRequest.showEdoviz) {
            columns.push(
                {
                    Header: "Edöviz",
                    accessor: "edovizCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.edovizCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.edovizCount + " Adet"}</p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.edovizDownload} onChange={(e) => this.onChangeChecked(index, "edovizDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                },
                {
                    Header: "Edöviz Rapor",
                    accessor: "edovizRaporCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.edovizRaporCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.edovizRaporCount + " Adet"}</p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.edovizRaporDownload} onChange={(e) => this.onChangeChecked(index, "edovizRaporDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                }
            );
        }

        if (downloadXmlRequest.showEadisyon) {
            columns.push(
                {
                    Header: "Eadisyon",
                    accessor: "eadisyonCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.eadisyonCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.eadisyonCount + " Adet"}</p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.eadisyonDownload} onChange={(e) => this.onChangeChecked(index, "eadisyonDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                }
            );
        }

        if (downloadXmlRequest.showRapor) {
            columns.push(
                {
                    Header: "Arşiv Rapor",
                    accessor: "raporCount",
                    sortable: false,
                    Cell: (row, index) => (
                        row.raporCount ?
                            <div>
                                <p style={{marginRight: 5, display: 'inline'}} className="text-success">{row.raporCount + " Adet"}</p>
                                <Input type="checkbox" style={{marginLeft: "0px"}} checked={row.raporDownload} onChange={(e) => this.onChangeChecked(index, "raporDownload", e.target.checked)}/>
                            </div>
                            :
                            "Kayıt Yok"
                    )
                }
            )
        }

        const columns2 = [
            {
                Header: "#",
                accessor: "recordId",
                sortable:false,
                Cell: (row,index)=>(<div style={{margin:0}}>{index+1}</div>)
            },
            {
                Header: "Tür",
                accessor: "type",
                sortable:false,
                Cell: row=>(<div style={{margin:0}}>{this.getTypeName(row.type)}</div>)
            },
            {
                Header: "Yıl",
                accessor: "year",
                sortable:false,
                Cell: row=>(<div style={{margin:0}}>{row.year>=2021 ? "2.Part" : "1.Part"}</div>)
            },
            {
                Header: "Bölüm",
                accessor: "part",
                sortable:false,
                Cell: row=>(<div>{row.part}</div>)
            },
            {
                Header: "Adet",
                accessor: "count",
                sortable:false,
                Cell: row=>(<div>{row.count}</div>)
            },
            {
                Header: "Durum",
                accessor: "state",
                sortable:false,
                Cell: row=>(this.getState(row))
            },
            {
                Header: "İşlenme Başlangıç",
                accessor: "processStartTime",
                sortable:false,
                Cell: row=>(<div>{moment(row.processStartTime).isValid() ? moment(row.processStartTime).format("DD-MM-YYYY HH:mm:ss") : ''}</div>)
            },
            {
                Header: "İşlenme Bitiş",
                accessor: "processFinishTime",
                sortable:false,
                Cell: row=>(<div>{moment(row.processFinishTime).isValid() ? moment(row.processFinishTime).format("DD-MM-YYYY HH:mm:ss") : ''}</div>)
            },
            {
                Header: "İşlemler",
                accessor: "",
                sortable:false,
                Cell: row=>(<div>
                    {row.state===2 &&
                    <a href={this.getUrl(row)}>
                        <button type="button"
                                data-toggle="tooltip" data-placement="bottom" title="Rapor XML İndir"
                                style={{background: 'rgba(23, 121, 190, 1)'}}
                                rel="tooltip" className="Btn btn-icon">
                            <i className="BtnIcon fa fa-download "/>
                        </button>
                    </a>
                    }
                </div>)
            }
	    ];

		return (
			<DefaultModal disabled={this.state.confirmBtnDisabled}
						  isOpen={this.props.modal}
						  title={this.props.title || ""}
                          size="xl"
						  confirmBtnText={this.state.type==="request"? "Gönder":""}
						  cancelBtnText="Kapat"
						  onConfirm={this.confirm}
						  onCancel={()=>this.props.isOpen(false)}
			>
                {this.state.type==="result"&&
                    <div className="col-sm-12" style={{position:"unset", margin:0}}>
                        <button type="button"
                                data-toggle="tooltip"
                                id="deleteResult"
                                onClick={this.deleteCustomerXMLRequest}
                                data-placement="bottom" title="Tümünü Sil"
                                style={{background: 'rgb(243, 157, 157)'}}
                                rel="tooltip" className="Btn btn-icon pull-right">
                            <i className="BtnIcon fa fa-trash"/>
                        </button>
                        <button type="button"
                                id="refreshResult"
                                onClick={this.getList}
                                data-toggle="tooltip" data-placement="bottom" title="Listeyi Yenile"
                                style={{background: 'rgba(23, 121, 190, 1)'}}
                                rel="tooltip" className="Btn btn-icon pull-right">
                            <i className="BtnIcon fa fa-refresh"/>
                        </button>
                    </div>
                }
                <div className="col-sm-12" style={{paddingTop:22,position:"unset", margin:0}}>
                    <Table
                        columns={this.state.type==="request" ? columns : columns2}
                        content={this.state.requestMap}
                        paginationEnabled={false}
                        loadingText={<ReactLoading type="spinningBubbles" style={{width:"45px", height: "45px", margin: "15px auto 0 auto", fill: "#888"}}/>}
                        loading={this.state.loading}
                        options={[]}
                        fetchData={()=>{}}
                    />
                </div>
            </DefaultModal>
		)
	}
}

export default XMLDownlaodRequestModal;